import React, { useState, useEffect } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from "reactstrap";
import Logo from "../Assets/Logo.svg";
import { useUser } from "../Context/userContext";
import { useLocation } from "react-router-dom";

const Toolbar = () => {
  const location = useLocation();
  const { selectedHostelId, setSelectedHostelId, hostels, role ,selectedHostelData } = useUser();

  const [isLaptop, setIsLaptop] = useState(window.matchMedia("(min-width: 769px)").matches);
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showNoticePopup, setShowNoticePopup] = useState(false);


  let disabledInventoryTab = selectedHostelData?.on_boarded

  useEffect(() => {
    const laptopQuery = window.matchMedia("(min-width: 769px)");
    const mobileQuery = window.matchMedia("(max-width: 768px)");
    const handleLaptop = (e) => setIsLaptop(e.matches);
    const handleMobile = (e) => setIsMobile(e.matches);
    laptopQuery.addEventListener("change", handleLaptop);
    mobileQuery.addEventListener("change", handleMobile);
    return () => {
      laptopQuery.removeEventListener("change", handleLaptop);
      mobileQuery.removeEventListener("change", handleMobile);
    };
  }, []);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleChange = (hostel) => {
    setSelectedHostelId(hostel);
  };
const showDropdown = hostels?.length > 1?true:false;
  return (
    <>
      {showNoticePopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px"
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              maxWidth: "560px",
              width: "100%",
              padding: "24px",
              textAlign: "center",
              boxShadow: "0 12px 24px rgba(0, 0, 0, 0.2)"
            }}
          >
            <h5 style={{ marginBottom: "12px" }}>Important Notice</h5>
            <p style={{ marginBottom: "20px" }}>
              The business site is offline for 24 hours for launch of new features - in case of any urgency reach out to 9673203092
            </p>
            <button
              type="button"
              onClick={() => setShowNoticePopup(false)}
              style={{
                border: "none",
                backgroundColor: "#0d6efd",
                color: "#fff",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              Okay
            </button>
          </div>
        </div>
      )}
      {isMobile && (
        <div>
          <div className="d-flex justify-content-between m-3 gap-3 align-items-center mb-4">
            <img src={Logo} alt="Hostel-Co" className="d-inline-block" style={{ height: "40px" }} />
            <div className="d-flex flex-column text-end gap-3">
              <div style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => { localStorage.removeItem("token"); window.location.reload(); }}>
                Logout
              </div>
              {showDropdown && (
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {selectedHostelId
                      ? (hostels.find(h => h.id === selectedHostelId)?.hostel_name || `Hostel ${selectedHostelId}`)
                      : "Select Hostel"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {hostels.map((hostel ,index) => (
                      <DropdownItem 
                        key={`${hostel.id} + ${index}`}
                        onClick={() => handleChange(hostel.id)}
                        active={selectedHostelId === hostel.id}
                      >
                        {hostel.hostel_name} (ID: {hostel.id})
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              )}
              
            </div>
          </div>
          <div className="d-flex gap-4 business-navbar" style={{  overflowX:"auto", marginLeft: "53px", marginTop: "50px", fontSize: "12px" }}>
          <NavLink className="nav-mobile"   style={{
    cursor: disabledInventoryTab ? "not-allowed" : "pointer",
    opacity: disabledInventoryTab ? 0.5 : 1
  }}  disabled={disabledInventoryTab} active={location.pathname === "/inventory"} href="/inventory">
                    Inventory
                  </NavLink>
            <NavLink className="nav-mobile" active={location.pathname === "/reservation"} href="/reservation">
              Reservation
            </NavLink>
            <NavLink className="nav-mobile" active={location.pathname === "/payments"} href="/payments">
              Payments
            </NavLink>
            <NavLink className="nav-mobile" active={location.pathname === "/deductions"} href="/deductions">
              deductions
            </NavLink>
            <NavLink className="nav-mobile" active={location.pathname === "/saved-discounts"} href="/saved-discounts">
              Discount List
            </NavLink>
          </div>
        </div>
      )}
      {isLaptop && (
        <div>
          <div className="d-flex justify-content-between m-3 gap-3 align-items-center mb-4">
            <img src={Logo} alt="Hostel-Co" className="d-inline-block" style={{ height: "40px" }} />
            <div className="d-flex flex-column text-center gap-3">
              <div style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => { localStorage.removeItem("token"); window.location.reload(); }}>
                Logout
              </div>
              {showDropdown && (
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {selectedHostelId
                      ? (hostels.find(h => h.id === selectedHostelId)?.hostel_name || `Hostel ${selectedHostelId}`)
                      : "Select Hostel"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {hostels.map((hostel , index ) => (
                      <DropdownItem
                                             key={`${hostel.id} + ${index}`}
                        onClick={() => handleChange(hostel.id)}
                        active={selectedHostelId === hostel.id}
                      >
                        {hostel.hostel_name} (ID: {hostel.id})
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              )}
              
            </div>
          </div>
          <div className="mx-5">
            
            <div className="col-lg-6 col-12">
              <Nav fill pills>
                <NavItem>
                  <NavLink   style={{
    cursor: disabledInventoryTab ? "not-allowed" : "pointer",
    opacity: disabledInventoryTab ? 0.5 : 1
  }}  disabled={disabledInventoryTab} active={location.pathname === "/inventory"} href="/inventory">
                    Inventory
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink active={location.pathname === "/reservation"} href="/reservation">
                    Reservation
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink active={location.pathname === "/payments"} href="/payments">
                    Payments
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink active={location.pathname === "/deductions"} href="/deductions">
                    Deductions
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink active={location.pathname === "/saved-discounts"} href="/saved-discounts">
                    Discount List
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Toolbar;